export default "__VITE_ASSET___3XwTa6D__"